import { NftTraitGuildName } from '../nft';

type NftTraitName =
  | 'Color'
  | 'Box'
  | 'Clan'
  | 'Design'
  | 'Body'
  | 'Character'
  | 'Tattoo'
  | 'Weapon'
  | 'Accessory';

export type GeneralNftTraitName = Exclude<
  NftTraitName,
  'Color' | 'Box' | 'Clan'
>;

export type SpecificNftTraitName = Extract<
  NftTraitName,
  'Color' | 'Box' | 'Clan'
>;

const boxColors = ['blue', 'original', 'neon'] as const;
export type NftTraitBoxColor = typeof boxColors[number];
export const isNftTraitBoxColor = (input: any): input is NftTraitBoxColor => {
  return boxColors.includes(input);
};

const handColors = ['Pale', 'Porcelan', 'Yellow', 'Dark', 'Tanned'] as const;
export type NftTraitHandColor = typeof handColors[number];
export const isNftTraitHandColor = (input: any): input is NftTraitHandColor => {
  return handColors.includes(input);
};

interface GeneralTrait {
  traitType: GeneralNftTraitName;
  value: string;
}

interface ITraitSpecific {
  traitType: SpecificNftTraitName;
  value: NftTraitHandColor | NftTraitBoxColor | NftTraitGuildName;
}

interface HandColorTrait extends ITraitSpecific {
  traitType: 'Color';
  value: NftTraitHandColor;
}

interface BGTrait extends ITraitSpecific {
  traitType: 'Box';
  value: NftTraitBoxColor;
}

interface GuildTrait extends ITraitSpecific {
  traitType: 'Clan';
  value: NftTraitGuildName;
}

export type NftTrait = GeneralTrait | HandColorTrait | BGTrait | GuildTrait;
